import {
  CircularProgress,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useRef } from "react";
import SearchIcon from "@mui/icons-material/Search";

type item = {
  value: number | string;
  label: string | number;
};

interface IProps {
  items: item[];
  initValue?: number | string;
  inputLabel: string;
  searchInputLabel: string;
  loading: boolean;
  errorMessage?: boolean | string;
  handleSearch: (event: any) => void;
  handleSelect: (event: any) => void;
}

export default function SearchableSelect({
  initValue,
  items,
  inputLabel,
  searchInputLabel,
  loading,
  errorMessage,
  handleSearch,
  handleSelect,
}: IProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <FormControl fullWidth error={Boolean(errorMessage)}>
      <InputLabel variant="standard" id={inputLabel}>
        {inputLabel}
      </InputLabel>
      <Select
        labelId={inputLabel}
        id={`${inputLabel}-select`}
        value={initValue || ""}
        label={inputLabel}
        onChange={handleSelect}
        variant="standard"
        onAnimationEnd={() => inputRef.current?.focus()}
        MenuProps={{ autoFocus: false }}
      >
        <ListSubheader
          sx={{
            padding: "10px 16px",
            borderBottom: "2px solid #d3d3d3",
            mb: 1.5,
          }}
        >
          <TextField
            InputProps={{
              ref: inputRef,
              startAdornment: (
                <InputAdornment position="start">
                  {loading ? (
                    <CircularProgress
                      sx={{
                        width: "20px !important",
                        height: "20px !important",
                      }}
                    />
                  ) : (
                    <SearchIcon />
                  )}
                </InputAdornment>
              ),
            }}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
            fullWidth
            id="search-input"
            label={searchInputLabel}
            variant="outlined"
            onChange={handleSearch}
          />
        </ListSubheader>
        {items.length > 0 ? (
          items.map((item, index) => (
            <MenuItem key={`${item.label} - ${index}`} value={item.value}>
              {item.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No results found</MenuItem>
        )}
      </Select>
      {Boolean(errorMessage) && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
}
